<template>
    <div class="ObjectPage">
        <PagePanelWrapper>
            <div class="ObjectPage__back" @click="$router.back()">
                <ArrowIcon/>
                <span class="ObjectPage__back-text">Вернуться</span>
            </div>
            <div class="ObjectPage__download" v-if="object.presentation">
                <FileIcon/>
                <span class="ObjectPage__download-text"><a :href="object.presentation">Скачать презентацию</a></span>
            </div>
        </PagePanelWrapper>
        <div class="container">
            <div class="ObjectPage__full-object">
                <FullObject v-bind="object" @open="imageOpened = $event"/>
            </div>
            <div class="ObjectPage__location-objects">
                <LocationObjects @open="imageOpened = $event" :object="object"/>
            </div>
        </div>
        <div class="container">
            <div class="ObjectPage__other-objects-title mobile-container">
                Другие {{otherObjectTypeName}} {{getObjectLocation}}
            </div>
            <ObjectList v-if="object.type === 'country_houses'" :objects="filterObjectByType('country_houses', object.village, object.id,  3)"/>
            <!--<ObjectList v-else-if="object.type = 'apartment'" :objects="filterObjectByType('apartment', 6)"/>-->
            <ObjectList v-else-if="object.type === 'town_flats'" :objects="filterObjectByType('town_flats', object.village, object.id,  3)"/>
            <ObjectList v-else-if="object.type === 'country_lands'" :objects="filterObjectByType('country_lands', object.village, object.id,  3)"/>
            <ObjectList v-else :objects="objects.slice(0, 3)"/>
        </div>
        <div class="ObjectPage__appointment hide-tablet">
            <div class="container">
                <div class="ObjectPage__appointment-content">
                    <div class="ObjectPage__name">{{object.name}}</div>
                    <div class="ObjectPage__appointment-main">
                        <div class="ObjectPage__price">
                            <ObjectPrice v-bind="object.price" :tp="object.tp"/>
                        </div>
                        <ObjectAppointment :id="object.id"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="show-tablet">
            <FooterWithObjectAppointment/>
        </div>
        <div class="ObjectPage__ObjectAppointment show-tablet" :class="{bottom: scrollBottom}">
            <ObjectAppointment :id="object.id"/>
        </div>

        <Modal class="image-modal-full" :open="imageOpened" @close="imageOpened = false" :images_count="images_count(imageOpened)" :data-count="images_count()">
           <img  v-for="item in imageOpened" :src="item" :key="item">
        </Modal>
    </div>
</template>

<script>
import PagePanelWrapper from "@/components/PagePanelWrapper";
import ArrowIcon from '@/assets/image/icons/arrow-left.svg?inline';
import FileIcon from '@/assets/image/icons/file.svg?inline';
import {mapGetters, mapState} from "vuex";
import FullObject from "@/components/Object/FullObject";
import LocationObjects from "@/components/Object/LocationObjects";
import ObjectAppointment from "@/components/Object/ObjectAppointment";
import ObjectPrice from "@/components/Object/ObjectPrice";
import ObjectList from "@/components/Object/ObjectList";
import FooterWithObjectAppointment from "@/components/FooterWithObjectAppointment";
import scrollBottomWatch from "@/mixins/scrollBottomWatch";
import Modal from "@/components/Modal";

export default {
    name: "ObjectPage",
    mixins: [scrollBottomWatch],
    components: {
        Modal,
        PagePanelWrapper,
        ArrowIcon,
        FileIcon,
        FullObject,
        LocationObjects,
        ObjectAppointment,
        ObjectPrice,
        ObjectList,
        FooterWithObjectAppointment,
    },
    data: ()=> ({
        imageOpened: false
    }),
    /*props: {
        arr: Array,
    },*/
    computed: {
        object() {
            return this.getObjectById(this.$route.params.id);
        },
        otherObjectTypeName() {
            if (this.object.type === '') return '';
            if (this.object.type === 'town_flats') return 'квартиры';
            if (this.object.type === 'country_lands') return 'участки';
            return 'дома';
        },
        getObjectLocation() {

            if (this.objects.filter(object => object.type === this.object.type && object.village === this.object.village && object.id !== this.object.id).length > 0) {
                if (this.object.type === 'country_houses' || this.object.type === 'country_lands') {
                    return 'в поселке '+this.object.location_name;
                } else if (this.object.type === 'town_flats')  {
                    return 'в ЖК '+this.object.location_name;
                }
            }

            return '';
        },
        arr() {
            let a = this.objects.slice(0);
            a.sort(() => Math.random() - 0.5);
            return a;
        },
        ...mapState(['objects']),
        ...mapGetters(['getObjectById'])
    },
    methods: {
        filterObjectByType(type, parent, id, length) {

            let obj = this.objects
                .filter(object => object.type === type && object.village === parent && object.id !== id)
                .slice(0, length);

            /** если нет других объектов в том же поселке (ЖК), то вывод рандомно объектов из других поселков (ЖК) */
            if (obj.length === 0) {
                let a = this.arr;
                //this.object.type = '';

                obj = a
                    .filter(object => object.type === type && object.id !== id)
                    .slice(0, 3);
            }

            return obj;
        },

        images_count(imageOpened) {

            let i = 0;
            for (let item in imageOpened) {
                if (item) {
                    i++;
                }
            }
            return i;
        }

    }
}
</script>

<style lang="scss">
.ObjectPage {
    padding-top: 30px;//130px;
  padding-bottom: 130px;

  .image-modal-full .Modal__content {
    text-align: center;
    max-width: 1000px;//90%;
    max-height: 85%;
    height: 100%;
      padding: 10px 0;
    background: white;
      overflow-scrolling: auto;

    svg {
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;

      path {
        fill: $white;
      }
    }

    img {
      max-width: 100%;
      max-height: 90vh;
        //height: 90%;
        display: inline-block;
        padding: 10px;
    }
  }

  &__ObjectAppointment {
    position: sticky;
    bottom: 0;
    left: 56px;
    right: 56px;

    .ObjectAppointment__button {
      border-radius: 0;
    }

    &.bottom {
      position: relative;
      bottom: 30px;
      left: auto;
      right: auto;

      @include mobile {
        bottom: -2px;
        left: 0;
        right: 0;
      }

      .ObjectAppointment .ObjectAppointment__button {

        @include tablet {
          width: calc(100% - 100px);
          margin: 0 auto;
          box-shadow: $BlockShadow;
          background-color: $white;
          color: $primary;
          @include svgFill($primary);
          border-radius: 4px;
          &:hover {
            background-color: rgba($white, 0.9);
          }
        }

        @include mobile {
          width: 100%;
          margin-bottom: -2px;
          border-radius: 0;
        }
      }
    }
  }

  @include tablet {
      padding-top: 45px;
    padding-bottom: 0;
  }

  &__full-object {
    margin-bottom: 24px;
  }

  &__location-objects {
    margin-bottom: 64px;

    @include mobile {
      margin-bottom: 40px;
    }
  }

  &__back, &__download {
    display: flex;
    align-items: center;
  }

  &__back-text {
    cursor: pointer;
    margin-left: 8px;
    color: $textLightBlack;
  }

  &__download-text {
    cursor: pointer;
    font-weight: 500;
    color: $primary;
    margin-left: 4px;
  }

  &__appointment {
    z-index: 100;
    position: fixed;
    display: flex;
    align-items: center;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 72px;

    background-color: $white;
    box-shadow: $BlockShadow;
    padding: 0 12px;
  }

  &__appointment-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__appointment-main {
    display: flex;
    align-items: center;
  }

  &__name {
    font-size: 16px;
    line-height: 24px;
    margin-right: 40px;
  }

  &__price {
    margin-right: 32px;
  }

  &__other-objects-title {
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 32px;

    @include mobile {
      font-size: 20px;
      margin-bottom: 24px;
    }
  }
}
</style>
